module.exports = __webpack_public_path__ + "static/media/ondrej-clo.711387ae.png";